import { render } from "./Zhengcezhichi.vue?vue&type=template&id=0cd13350&scoped=true"
import script from "./Zhengcezhichi.vue?vue&type=script&lang=js"
export * from "./Zhengcezhichi.vue?vue&type=script&lang=js"

import "./Zhengcezhichi.vue?vue&type=style&index=0&id=0cd13350&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd13350"]])

export default __exports__